import { Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { BaseChartDirective, Color, Label } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ReportService } from 'src/app/services/report/report.service';

@Component({
  selector: 'app-acc-dis-report',
  templateUrl: './acc-dis-report.component.html',
  styleUrls: ['./acc-dis-report.component.scss']
})
export class AccDisReportComponent implements OnInit {
  @ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective;

  @Input() query: any;
  @Input() genReportEvent: EventEmitter<string>;

  reportLoading = false;
  detailSaleChartPlugins = [pluginAnnotations];
  labels: Label[] = ['AMZ', 'Ebay', 'Etsy'];

  data: ChartDataSets[] = [
    {
      label: 'ACC',
      data: [100, 100, 100, 100, 100, 100],
    },
  ];

  chartOptions: ChartOptions = {
    animation: {
      duration: 1,
    },
    title: {
      display: true,
      text: 'Phân bổ tài khoản'
    }    
  }

  constructor(private reportService:ReportService) { }

  ngOnInit(): void {
    
    this.genReportEvent.subscribe(data => {
      
      var query = JSON.parse(JSON.stringify(this.query));
      query.startDate = moment(query.startDate).format();
      query.endDate = moment(query.endDate).format();
      this.reportLoading = true;
      this.reportService.getAccDisReport(query).subscribe((data) => {
        this.labels = _.map(data, i => i.label);
        this.data[0].data  = _.map(data, i=> i.amount);
        this.chart.updateColors();
        this.chart.update();
        this.reportLoading = false;
      })
    });
  }
}
